// extracted by mini-css-extract-plugin
export var logo = "_kd-2";
export var logoWrapper = "_kd-1";
export var strip = "_kd-0";